<template>
    <div>

        <b-modal id="create-or-update-size-info" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <employee-size-information-create-or-update v-model="size" :errors="errors"></employee-size-information-create-or-update>
            <template #modal-footer><v-executer  :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>
        
        <v-table    ref="table"
                    search
                    up-class="px-1 pb-1"
                    with-items
                    :items="value"
                    name="employee-size-information"
                    :add-callback="createNew"
                    :buttons="buttons"
                    overlay-class="pb-0"
                    :fields="fields"></v-table>

    </div>
</template>

<script>
import EmployeeSizeInformationCreateOrUpdate from './EmployeeSizeInformationCreateOrUpdate.vue'
import randomatic from 'randomatic'

export default {
    components:{
        EmployeeSizeInformationCreateOrUpdate,
    },
    props:{
        value:Array,
        id:[String,Number]
    },
    data(){
        return{
            fields:[
                {name:"Beden Bilgisi",key:"SizeInformationName",thClass:"w-50"},
                {name:"Değer",key:"ParameterOfSizeInformationName",thClass:"w-50"},
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            size:{
                Id:null,
                SizeInformationId:null,
                SizeInformationName:null,
                ParameterOfSizeInformationId:null,
                ParameterOfSizeInformationName:null,
                EmployeeId:null
            },
            errors:{},
            editing:false,
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.size.Id = null
            this.size.SizeInformationId = null
            this.size.SizeInformationName = null
            this.size.ParameterOfSizeInformationId = null
            this.size.ParameterOfSizeInformationName = null
            this.size.EmployeeId = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update-size-info')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.size.Id = item.Id
            this.size.SizeInformationId = item.SizeInformationId
            this.size.SizeInformationName = item.SizeInformationName
            this.size.ParameterOfSizeInformationId = item.ParameterOfSizeInformationId
            this.size.ParameterOfSizeInformationName = item.ParameterOfSizeInformationName
            this.size.EmployeeId = item.EmployeeId
            this.$showModal('create-or-update-size-info')
        },
        validation(){
            let count = 0
            if(this.$isNullOrEmpty(this.size.SizeInformationId)){
                this.$set(this.errors,'SizeInformationId','Beden bilgisi alanı zorunludur.')
                count ++
            }
            if(this.$isNullOrEmpty(this.size.ParameterOfSizeInformationId)){
                this.$set(this.errors,'ParameterOfSizeInformationId','Beden değeri alanı zorunludur.')
                count ++
            }
            return count > 0 ? false : true
        },
        createOrUpdate(){
            if(this.validation()){
                if(this.size.Id){
                    let item = this.value.find(r=> r.Id == this.size.Id)
                    this.$set(item,"SizeInformationId",this.size.SizeInformationId)
                    this.$set(item,"SizeInformationName",this.size.SizeInformationName)
                    this.$set(item,"ParameterOfSizeInformationId",this.size.ParameterOfSizeInformationId)
                    this.$set(item,"ParameterOfSizeInformationName",this.size.ParameterOfSizeInformationName)
                    this.$set(item,"EmployeeId",this.size.EmployeeId)
                    this.$set(item,"Unsaved",true)
                }else{
                    this.value.push({
                        Id:randomatic("A0",10),
                        SizeInformationId:this.size.SizeInformationId,
                        SizeInformationName:this.size.SizeInformationName,
                        ParameterOfSizeInformationId:this.size.ParameterOfSizeInformationId,
                        ParameterOfSizeInformationName:this.size.ParameterOfSizeInformationName,
                        Size:this.size.Size,
                        EmployeeId:this.size.id,
                        Unsaved:true
                    })
                }
                this.$hideModal('create-or-update-size-info')
            }
        },
        delete(item,key,index){
            this.$confirm("Silmek istediğinize emin misiniz?",`Bu işlem beden bilgisini silecektir ve geri alınamaz.`).then(res=>{
                if(res){
                    this.$delete(this.value,index)
                }
            })
        },
    }
}
</script>

<style>

</style>